import { AppDispatch } from '../../../../redux/store'
import { getPackagingProcessingActivity, getPackagingProcessingActivityConfiguration } from './api'
import {
  packagingProcessFailure,
  packagingProcessRequest,
  packagingProcessSuccess,
  configuration,
} from '../../../../redux/packagingProcessSlice'
import { showCorrelationIdError } from '../../../../redux/correlationIdSlice'
import { mapIngredientToMaterialRow, mapProductToComponentState } from './utils'

export const fetchPackagingProcess =
  (pieceId: string, replace) => async (dispatch: AppDispatch) => {
    try {
      dispatch(packagingProcessRequest())
      const { data: pieceData } = await getPackagingProcessingActivity(pieceId)
      // BE's `materials` array is the shared Ingredients DTO shape (inputIngredientId/Type/Level per
      // D3) — translate to the FE's Category/FunctionalUnit vocabulary before it hits the form.
      // Same for `component` — BE's single ProductQuantityDTO shape vs the form's flat
      // packagingComponentId/componentScalingFactor fields.
      dispatch(
        packagingProcessSuccess({
          ...pieceData,
          materials: (pieceData.materials || []).map(mapIngredientToMaterialRow),
          ...mapProductToComponentState(pieceData.component),
          // BE's wire key is inputElementaryFlows (no flat rename needed for outputElementaryFlows,
          // its key already matches) — the form field is elementaryFlows.
          elementaryFlows: pieceData.inputElementaryFlows || [],
          outputElementaryFlows: pieceData.outputElementaryFlows || [],
        })
      )
    } catch (error: any) {
      if (error.showCorrelationId) {
        dispatch(showCorrelationIdError(error.CorrelationId))
      }
      if (error.response.status === 400) {
        replace()
      }
      dispatch(packagingProcessFailure(error.message))
    }
  }

export const getConfiguration = () => async (dispatch: AppDispatch) => {
  try {
    const { data: configurationData } = await getPackagingProcessingActivityConfiguration()
    dispatch(configuration(configurationData))
  } catch (error: any) {
    if (error.showCorrelationId) {
      dispatch(showCorrelationIdError(error.CorrelationId))
    }
    dispatch(packagingProcessFailure(error.message))
  }
}
